import FieldResult from 'components/Form/FieldResult';
import Progress, {ProgressRef} from 'components/Loaders/Progress';
import Modal from 'components/Modal';
import {LongTaskResponseErrorResponse} from 'hooks/useGetLongTaskProgress';
import {FC, RefObject} from 'react';
import {t} from 'ttag';
import {LongTask} from 'types/long-task';

import {ClientInboxDocument} from '../services';

export type DownloadDocumentModalProps = {
    downloadRef: RefObject<HTMLAnchorElement>;
    isOpen: boolean;
    longTask: LongTask | undefined;
    longTaskApiError: LongTaskResponseErrorResponse | undefined;
    onClose: () => void;
    progressRef: RefObject<ProgressRef>;
    selectedDocuments: ClientInboxDocument[];
};

const DownloadDocumentModal: FC<DownloadDocumentModalProps> = ({
    downloadRef,
    isOpen,
    longTask,
    longTaskApiError,
    onClose,
    progressRef,
    selectedDocuments,
}) => {
    const numberOfItems = selectedDocuments.filter((d) => d.selected).length;

    return (
        <Modal isOpen={isOpen} onClose={onClose} preventOutsideClick={true}>
            <Modal.Header>
                {t`Preparing download of ${numberOfItems} Documents..`}
            </Modal.Header>
            <Modal.Body>
                <Progress ref={progressRef} />
                <div className="mb-4">
                    <p>{t`The selected Documents will be compressed into a ZIP file and then the download will begin. This message will close automatically after download.`}</p>
                    {longTask?.finished &&
                        longTask?.resultUrl &&
                        !longTask?.uilongtask.errors.length && (
                            <a
                                className="mt-6"
                                download={true}
                                href={longTask.resultUrl}
                                ref={downloadRef}
                                rel="noreferrer"
                                target="_blank"
                            >
                                {t`Download`}
                            </a>
                        )}
                </div>
                {(longTask?.uilongtask.errors.length || longTaskApiError) && (
                    <div className="mt-4 text-coral-500">
                        {t`An error occurred. Please try again later.`}
                    </div>
                )}
                <FieldResult className="mt-4" name="downloadResult" />
            </Modal.Body>
            <Modal.Footer>
                <Modal.Button
                    kind="tertiary"
                    onClick={onClose}
                    size="sm"
                    type="cancel"
                >
                    {t`Cancel`}
                </Modal.Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DownloadDocumentModal;
